<ion-input class="floating-label-input" [value]="value" type="text" pattern="^\d{4}-\d{1,2}-\d{1,2}$"
  (ionInput)="onInputChange($event)" (ionFocus)="isFocused = true" (ionBlur)="onInputBlur()"
  (keydown)="onkeydown ? onkeydown($event) : null" inputmode="numeric" [attr.required]="required ? true : null"
  [class.invalid]="isInvalid" [attr.maxlength]="10" [attr.minlength]="8" [attr.inputmode]="inputmode ? inputmode : null"
  color="dark" [placeholder]="isFocused ? placeholder : ''">
</ion-input>